import { Paper, Tooltip } from '@mui/material';
import { withStyles, styled as MuiStyled } from '@mui/styles';
import styled, { keyframes } from 'styled-components';

export const SchemaWrap = MuiStyled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
  backgroundColor: '#fff',
  overflowX: 'hidden',
  position: 'relative',
});

export const DrawingAreaWrap = MuiStyled('div')(() => ({
  height: '100%',
  backgroundColor: '#fafafa',
  overflow: 'auto',
  position: 'relative',
}));

export const DrawingAreaBeforeSVG = MuiStyled(Paper)({
  margin: 20,
  padding: 15,
  '@media (max-width: 576px)': {
    margin: '1em',
    padding: '1em',
  },
});

export const DrawingAreaSVG = MuiStyled('svg')({
  position: 'relative',
  width: '100%',
  height: '100%',
});

export const Connection = MuiStyled('path')((props) => {
  const styledProps = props['data-styled'] || {};
  const { showEnergyFlow, reverseDirection, isSourceNode } = styledProps;
  const dashDirection = reverseDirection
    ? (isSourceNode ? 'dash' : 'reverse-dash')
    : (isSourceNode ? 'reverse-dash' : 'dash');

  return {
    stroke: showEnergyFlow ? reverseDirection ? '#fdc461' : '#72c499' : '#ccc',
    strokeWidth: '2',
    ...(
      showEnergyFlow ? {
        transform: 'translate(0.5, 0.5)',
        strokeDasharray: '4 1',
        animation: `${dashDirection} 1s linear infinite`,
      } : {}
    ),
  };
});

export const EnergyDirection = MuiStyled('svg')({
  overflow: 'visible',
  '& path': {
    stroke: ({ direction }) => (direction === 'IN' ? '#72c499' : '#fdc461'),
    strokeWidth: 2,
    fill: 'none',
    animation: 'energy-flow-direction-in 1200ms linear infinite',
    '&:first-child': {
      animationDelay: '0',
    },
    '&:nth-child(2n)': {
      animationDelay: '100ms',
    },
    '&:nth-child(3n)': {
      animationDelay: '200ms',
    },
  },
});

export const ZoomControlsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 150px;
  height: 30px;
  border: solid 1px #ddd;
  border-radius: 3px 3px 0 0;
  margin: 36px 0 0 36px;
  z-index: 5;

  @media (max-device-width: 1224px) {
    bottom: 25px;
    right: 5px;
  }
`;

export const ZoomButton = MuiStyled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(25% - 1px)',
  margin: '1px 0 0 1px',
  height: 'calc(100% - 2px)',
  cursor: 'pointer',
  background: '#eee',
  '&.inactive .MuiSvgIcon-root': {
    color: '#ccc',
    '&:hover': {
      color: '#ccc',
    },
  },
  '&:last-child': {
    margin: '1px 1px 0 1px',
  },
  '& .MuiSvgIcon-root': {
    color: '#666',
    '&:hover': {
      color: '#555',
    },
  },
});

// Editing elements

export const RemoveConnectionTriggerWrap = MuiStyled('svg')({
  width: '8px',
  height: '8px',
  cursor: 'pointer',
  fill: '#fff',
  '& rect': {
    width: 8,
    height: 8,
    fill: 'transparent',
  },
  '& path': {
    stroke: '#ff0000',
    strokeWidth: 1,
  },
});

const Blink = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const ControlWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: #a6a6a6;
  border-radius: 20px;
  cursor: pointer;

  .MuiSvgIcon-root {
    font-size: 12px;
    color: #fff;
  }

  &.unchained {
    position: relative;
    background-color: #FAEF25;
    color: #000;
    cursor: default;
    animation: ${Blink} 1s ease-out infinite;

    .MuiSvgIcon-root {
      color: #000;
    }
  }
`;

export const TooltipWrap = withStyles(() => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#333',
    fontSize: '14px',
    maxWidth: 220,
    borderRadius: 0,
    fontWeight: 'normal',
    border: '1px solid #dadde9',
    '& .description': {
      margin: '5px 0 10px',
    },
    '& .preview': {
      width: '222px',
      height: '122px',
    },
  },
}))(Tooltip);
